module.exports = __webpack_public_path__ + "static/media/26.62505fb8.webp";